import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Translation } from 'react-i18next';

const LocationsList = (props) => {
  return (
    <div className={`sb-location-list-back ${props.selectedLocationId ? 'sb-has-selected-location' : ''}`}>
      <a title={i18n.t('displayLocationsList')} href="#locations-list" onClick={props.handleClick}><Translation>{(t) => t('View List')}</Translation></a>
      <span>{props.locationsLength} <Translation>{(t) => t('locations near you')}</Translation></span>
    </div>
  );
};

LocationsList.propTypes = {
  handleClick: PropTypes.func,
  locationsLength: PropTypes.number,
  selectedLocationId: PropTypes.string,
};

export default LocationsList;
